import React from 'react';
import PropTypes from 'prop-types';
import { Fab, TableCell } from '@material-ui/core';
import { RestorePage } from '@material-ui/icons';


const EditHistoryButton = ({ exceptionType, onClick }) => {
  const renderExceptionTypes = [15, 16];
  const renderEditButton = renderExceptionTypes.includes(parseInt(exceptionType, 10));
  const style = {
    backgroundColor: renderEditButton ? 'rgb(242, 170, 0)' : 'lightgray',
    color: 'white',
  };

  return (
    <div style={{ justifySelf: 'center' }}>
      <TableCell width="50px">
        <Fab
          size="small"
          style={style}
          disabled={!renderEditButton}
          onClick={onClick}
        >
          <RestorePage />
        </Fab>
      </TableCell>
    </div>
  );
};

EditHistoryButton.propTypes = {
  exceptionType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

EditHistoryButton.defaultProps = {};

export default EditHistoryButton;
